import { render, staticRenderFns } from "./daichuli.vue?vue&type=template&id=d1b45618&scoped=true&"
import script from "./daichuli.vue?vue&type=script&lang=js&"
export * from "./daichuli.vue?vue&type=script&lang=js&"
import style0 from "./daichuli.vue?vue&type=style&index=0&id=d1b45618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b45618",
  null
  
)

export default component.exports